import {
    SET_HAS_APP_RECEIVED,
    SET_HAS_HEADER_RECEIVED, SET_PPID, SET_HEADER_VALUES, SET_MODEL,
    SET_OPERATE_VER, SET_SAME_MENU_ITEM_CLICK, SET_CURRENT_PLC,
    // @ Test user credentials
    SET_LOGIN_SUCCESS, SET_LOGOUT, SET_CHECK_SESSION,
    SET_SOFC_CONFIG, SET_USER_ARRAY, SET_IS_WARNING_AL
} from '../constants/actions';

const initialState = {
    hasHeaderReceived: false,
    ppid: 0,
    hasAppReceived: false,
    headerValues: null,
    model: 'M400 Gen 2',
    // ^ SOFC_HMI : header 메뉴 추가 
    operateVersion : '',
    sameMenuItemClick : false,
    currentPLC : '',
    // @ Test user Credentials
    user : null,
    isAuthenticated : false,
    userArray: null,
    // [UPDATE] Shutdown Ack
    isWarningAL : false
};

// TODO : case문으로 변경하기...
const headerReducer = (state = initialState, action) => {
    if (action.type === SET_HAS_HEADER_RECEIVED) {
        return {...state, hasHeaderReceived: action.hasHeaderReceived};
    } else if (action.type === SET_PPID){
        return {...state, ppid: action.ppid};
    } else if (action.type === SET_HAS_APP_RECEIVED){
        return {...state, hasAppReceived: action.hasAppReceived};
    } else if (action.type === SET_HEADER_VALUES){
        return {...state, headerValues: action.headerValues};
    } else if (action.type === SET_MODEL){
        return {...state, model: action.model};
    } else if(action.type === SET_OPERATE_VER){                         // ^ SOFC_HMI : header 메뉴 추가 
        return {...state, operateVersion : action.operateVersion}
    } else if(action.type === SET_SAME_MENU_ITEM_CLICK){                   // ^ SOFC_HMI : header 메뉴 추가 
        return {...state, sameMenuItemClick : action.sameMenuItemClick}
    } else if(action.type === SET_CURRENT_PLC){
        return {...state, currentPLC : action.currentPLC}
    } else if(action.type === SET_IS_WARNING_AL){
        return {...state, isWarningAL: action.isWarningAL}
    }
    
    // @ Test user credentials
    else if (action.type === SET_LOGIN_SUCCESS) {                      
        return {... state, user : action.user, isAuthenticated : true}
    } else if (action.type === SET_LOGOUT){
        return {...state, user : null, isAuthenticated : false}
    } else if (action.type === SET_CHECK_SESSION){
        return {...state, user : action.user, isAuthenticated : true}
    } else if (action.type === SET_SOFC_CONFIG){
        return {...state, sofcConfig : action.sofcConfig};
    } else if (action.type === SET_USER_ARRAY){
        return {...state, userArray: action.userArray};
    } else {
        return state; // reducer의 default는 state 반환 
    }
};

export default headerReducer;